export default "__VITE_ASSET__hNO3Mxb0__"